import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
} from "antd";

import React, { useState } from "react";

import { repeats } from "../../../RecurringWorkOrderData";
import dayjs from "dayjs";

function RcurringInformation({ edit, data, monthOptions, setOptions }) {

  const updatedOptions = monthOptions.map(option => {
    const matchingOption = data?.selectedMonths.find(item => item.value === option.value);
  
    if (matchingOption) {
      return { ...option, check: matchingOption.check };
    } else {
      return option;
    }
  });
  const [totalMonths, setTotalMonths] = useState("");

  const onChange = (e) => {
    console.log(e.target.value);
    setOptions(
      [...updatedOptions].map((object) => {
        if (object.value === e.target.value) {
          return {
            ...object,
            check: e.target.checked,
          };
        }
        return { ...object };
      })
    );
    setTotalMonths(updatedOptions);
  };
  const selectAll = () => {
    setOptions(
      [...updatedOptions].map((object) => {
        return {
          ...object,
          check: true,
        };
      })
    );
    console.log(updatedOptions);
  };
  const selectNone = () => {
    setOptions(
      [...updatedOptions].map((object) => {
        return {
          ...object,
          check: false,
        };
      })
    );
    console.log(updatedOptions);
  };

  console.log("data%%%%%%%%%", data?.startDate);
  console.log("recuring order details", updatedOptions);

  return (
    <Card title="Recurrence Information">
      {!edit ? (
        <Form colon={false} labelCol={{ span: 8 }} wrapperCol={{ span: 8 }}>
          <Form.Item label="Start on">
            <p>{data?.startDate}</p>
          </Form.Item>
          <Form.Item label="End on">
            <p>{data?.endDate}</p>
          </Form.Item>
          <Form.Item label="Frequency">
            <p>{data?.repeats}</p>
          </Form.Item>
        </Form>
      ) : (
          <><Form.Item label="Start on" required name="startDate">
          <DatePicker style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item label="End on" name="endDate">
          <DatePicker style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item label="Repeats" name="repeats">
          <Select options={repeats} defaultValue="Monthly" />
        </Form.Item>
        <Form.Item label="Post Day" required name="postDay">
          <Input />
        </Form.Item>
        <Form.Item
              label="Select Month(s)"
              name="selectMonth"
              initialValue={[]}
            >
              <Button type="link" style={{ padding: 0 }} onClick={selectAll}>
                All
              </Button>
              <Button type="link" onClick={selectNone}>
                None
              </Button>
              <br />
              <div>
                <Row style={{ marginTop: 8 }}>
                  {updatedOptions.slice(0, 4).map((month) => (
                    <Col key={month} span={6}>
                      <Checkbox
                        value={month.value}
                        onChange={onChange}
                        checked={month.check}
                      >
                        {month.value}
                      </Checkbox>
                    </Col>
                  ))}
                </Row>
                <Row style={{ marginTop: 8 }}>
                  {updatedOptions.slice(4, 8).map((month) => (
                    <Col key={month} span={6}>
                      <Checkbox
                        value={month.value}
                        onChange={onChange}
                        checked={month.check}
                      >
                        {month.value}
                      </Checkbox>
                    </Col>
                  ))}
                </Row>
                <Row style={{ marginTop: 8 }}>
                  {updatedOptions.slice(8).map((month) => (
                    <Col key={month} span={6}>
                      <Checkbox
                        value={month.value}
                        onChange={onChange}
                        checked={month.check}
                      >
                        {month.value}
                      </Checkbox>
                    </Col>
                  ))}
                </Row>
              </div>
            </Form.Item></>
      )}
    </Card>
  );
}

export default RcurringInformation;
